export default "https://cdn-shared.mathletics.com/teacher-modules/mx-portal/278/assets/images/three-essentials-300bdc09347553d135ba4b320346d77d.svg";